import Icon from '../components/Icon.vue'

Icon.register({
  'calendar-times': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M436 160H12C5.4 160 0 154.6 0 148V112C0 85.5 21.5 64 48 64H96V12C96 5.4 101.4 0 108 0H148C154.6 0 160 5.4 160 12V64H288V12C288 5.4 293.4 0 300 0H340C346.6 0 352 5.4 352 12V64H400C426.5 64 448 85.5 448 112V148C448 154.6 442.6 160 436 160zM12 192H436C442.6 192 448 197.4 448 204V464C448 490.5 426.5 512 400 512H48C21.5 512 0 490.5 0 464V204C0 197.4 5.4 192 12 192zM269.3 352L317.4 303.9C322.1 299.2 322.1 291.6 317.4 286.9L289.1 258.6C284.4 253.9 276.8 253.9 272.1 258.6L224 306.7 175.9 258.6C171.2 253.9 163.6 253.9 158.9 258.6L130.6 286.9C125.9 291.6 125.9 299.2 130.6 303.9L178.7 352 130.6 400.1C125.9 404.8 125.9 412.4 130.6 417.1L158.9 445.4C163.6 450.1 171.2 450.1 175.9 445.4L224 397.3 272.1 445.4C276.8 450.1 284.4 450.1 289.1 445.4L317.4 417.1C322.1 412.4 322.1 404.8 317.4 400.1L269.3 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/calendar-times.js
// module id = 9cFj
// module chunks = 144